import React from 'react';

export function GlassCard({ children, className = '', variant = 'gold', hover = true, fill = false }) {
  const baseClasses = 'relative overflow-hidden rounded-2xl backdrop-blur-xl';
  const variants = {
    gold: 'glass-card-gold-border',
    blue: 'glass-card-blue-border',
    premium: 'glass-card-premium',
    plain: 'glass-card',
  };
  const hoverClass = hover ? 'hover:-translate-y-1 transition-transform duration-300' : '';
  const innerClass = fill ? 'relative z-10 flex h-full min-h-0 flex-col' : 'relative z-10';

  return (
    <div className={`${baseClasses} ${variants[variant] || variants.gold} ${hoverClass} ${className}`}>
      <div className={innerClass}>{children}</div>
    </div>
  );
}

export function CountUpNumber({ end, duration = 2000, prefix = '', suffix = '', decimals = 0 }) {
  const [count, setCount] = React.useState(0);

  React.useEffect(() => {
    let startTime = null;
    const startValue = 0;

    function animate(timestamp) {
      if (!startTime) startTime = timestamp;
      const progress = Math.min((timestamp - startTime) / duration, 1);
      const eased = 1 - Math.pow(1 - progress, 3);
      const current = startValue + (end - startValue) * eased;
      setCount(current);

      if (progress < 1) {
        requestAnimationFrame(animate);
      }
    }

    requestAnimationFrame(animate);
  }, [end, duration]);

  const formatted = decimals > 0 ? count.toFixed(decimals) : Math.floor(count).toLocaleString();

  return (
    <span>
      {prefix}
      {formatted}
      {suffix}
    </span>
  );
}

export function ConnectWalletPrompt({ message = 'Connect your wallet to continue' }) {
  return (
    <div className="flex flex-col items-center justify-center py-16 px-4">
      <div className="w-20 h-20 rounded-full bg-gradient-to-br from-hash-gold/20 to-medora-blue/20 flex items-center justify-center mb-6">
        <img src="/images/icon-wallet-connect.svg" alt="Wallet" className="w-10 h-10" />
      </div>
      <h3 className="text-xl font-bold text-white mb-2 text-shadow-dark">Wallet Not Connected</h3>
      <p className="text-gray-400 text-center max-w-md mb-6">{message}</p>
    </div>
  );
}

export default GlassCard;
